import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes, Outlet, BrowserRouter, useLocation } from 'react-router-dom';

import './App.scss';

import { Header } from './pages/header';
import { Carroussel } from './pages/carroussel';
import { SimuleSuaRemessa } from './pages/simule-sua-remessa';
import { OperacoesCobalt } from './pages/operacoes-cobalt';
import { ParaSuaEmpresa } from './pages/para-sua-empresa';
import { ParaVoce } from './pages/para-voce';
import { NichosDeMercado } from './pages/nichos-de-mercado';
import { Rodape } from './pages/rodape';

import { AberturaConta } from './pages/abertura-de-conta';
import { AbrirContaAgora } from './pages/abertura-de-conta/pages/abrir-conta-agora';

import { QuemSomos } from './components/sobre-a-cobalt/quem-somos';
import { Operacional } from './components/sobre-a-cobalt/operacional';

import { CambioPronto } from './components/para-sua-empresa/pages/cambio-pronto';
import { ProdutosCredito } from './components/para-sua-empresa/pages/produtos-de-credito';
import { ProdutosProtecao } from './components/para-sua-empresa/pages/produtos-de-protecao';
import { MultiplasCotacoes } from './components/para-sua-empresa/pages/multiplas-cotacoes';
import { ProdutosExclusivos } from './components/para-sua-empresa/pages/produtos-exclusivos';

import { ProdutosParaVoce } from './components/para-voce';
const ResetScroll = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null
}
function App() {

  const [option, setOption] = useState(null);

  const [showHeaderButtons, setShowHeaderButtons] = useState(true)
  useEffect(() => {
    

    const OnScroll = () => {
      const footer = document.getElementById("footer")
      
      const rect = footer?.getBoundingClientRect()
      if(rect !== undefined){
        if(rect.top >= 0 &&
          (rect.bottom - rect.height) <= (window.innerHeight || document.documentElement.clientHeight)){
            setShowHeaderButtons(false)
        }else{
          setShowHeaderButtons(true)
        }
      }
    }
        const event = document.addEventListener("scroll", OnScroll)

    return document.removeEventListener("scroll", event)
  }, [])

  return (
    <BrowserRouter>
      <ResetScroll/>
      <Routes>

        {/* Abertura de Conta */}
        <Route path='/cadastro' element={<AbrirContaAgora />} />
        <Route path="/cadastro-juridico" element={<AberturaConta type={0} />} />
        <Route path="/cadastro-fisico" element={<AberturaConta type={1}/>} />
        <Route path='/'
          element={

            <div className='container'>
              <Header setOption={setOption} showHeaderButtons={showHeaderButtons}/>

              <div className='main-content' style={{ width: '100%' }}>
                <Outlet />
              </div>
              <Rodape />
            </div>
          }>

          <Route path="" element={
            <>
              <Carroussel />
              <SimuleSuaRemessa />
              <OperacoesCobalt />
              <ParaSuaEmpresa />
              <ParaVoce />
              <NichosDeMercado />
            </>
          }
          />

          {/* Sobre a cobalt */}
          <Route path="/quem-somos" element={<QuemSomos />} />
          <Route path="/operacional-passo-a-passo" element={<Operacional />} />

          {/* Para sua empresa */}
          <Route path="/cambio-pronto" element={<CambioPronto />} />

          <Route path="/produtos-de-credito" element={<ProdutosCredito />} />
          <Route path="/produtos-de-protecao" element={<ProdutosProtecao />} />

          {/* <Route path="/multiplas-cotacoes" element={<MultiplasCotacoes />} /> */}
          {/* <Route path="/produtos-exclusivos" element={<ProdutosExclusivos />} /> */}
          <Route path="*" element={<>404</>} />

          {/* Para sua você */}
          <Route path="/produtos-para-voce" element={<ProdutosParaVoce />} />
          <Route path="*" element={<>404</>} />

        </Route>
      </Routes>
    </BrowserRouter>


  );

}

export default App;
